import { esc } from "../ui/format.js";
import { uiGet } from "../ui/kit.js";

/**
 * Investments & Offers: one sidebar tab, two pages (Rachit, 2026-10-15:
 * "one tab and two buttons, one for Corporate Investments and one for Offers for You").
 *
 *   💼 Corporate Investments   views/investments.js (your portfolio, rounds, pitches)
 *   📨 Offers for You          views/offers.js (the Tank, offers from companies, buyers)
 *
 * The old "offers" tab key still works: shell.showTab("offers") opens this
 * tab on the Offers page. The page you picked is remembered.
 */

const IH_KEY = "ges.invest.page";

function ihPage() {
  try { return localStorage.getItem(IH_KEY) === "offers" ? "offers" : "investments"; } catch (e) { return "investments"; }
}

function ihSetPage(page) {
  try { localStorage.setItem(IH_KEY, page); } catch (e) { /* not remembered */ }
}

async function renderInvestHub(main, snap) {
  let page = ihPage();
  main.innerHTML = `
    <div class="ih">
      <div class="ih-switch" role="tablist" aria-label="Investments and offers">
        <button type="button" role="tab" class="ih-btn" data-ih="investments"><span class="ih-ico">💼</span>
          <span class="ih-txt"><b>Corporate Investments</b><em>Your portfolio: shares, startups and funding rounds</em></span></button>
        <button type="button" role="tab" class="ih-btn" data-ih="offers"><span class="ih-ico">📨</span>
          <span class="ih-txt"><b>Offers for You</b><em>The Tank, deals companies bring you, buyers</em></span><i class="ih-badge hidden"></i></button>
      </div>
      <div class="ih-body"></div>
    </div>`;
  const body = main.querySelector(".ih-body");
  const home = main.closest(".tab-view") && main.closest(".tab-view").querySelector(".tab-home");
  const show = async (p) => {
    page = p;
    ihSetPage(p);
    main.querySelectorAll("[data-ih]").forEach((b) => { b.classList.toggle("on", b.dataset.ih === p); b.setAttribute("aria-selected", String(b.dataset.ih === p)); });
    // the tab's chart is the portfolio's: it belongs on the Investments page only
    if (home) home.style.display = p === "offers" ? "none" : "";
    const host = document.createElement("div");
    body.replaceChildren(host);
    if (p === "offers") await window.renderOffers(host, snap);
    else await window.renderInvestments(host, snap);
  };
  main.querySelectorAll("[data-ih]").forEach((b) => b.addEventListener("click", () => { if (b.dataset.ih !== page) show(b.dataset.ih); }));
  // how much is waiting on the Offers page (founders in the Tank + offers from companies)
  Promise.all([uiGet("/tank").catch(() => null), uiGet("/offers").catch(() => null)]).then(([t, o]) => {
    const n = (t ? t.pitches.filter((p) => p.open).length : 0) + (o ? o.offers.length : 0);
    const badge = main.querySelector(".ih-badge");
    if (badge && n) { badge.textContent = esc(String(n > 9 ? "9+" : n)); badge.classList.remove("hidden"); }
  });
  await show(page);
}

window.renderInvestHub = renderInvestHub;
window.gesInvestPage = ihSetPage;

export { renderInvestHub, ihSetPage };
